export default __webpack_public_path__ + "static/media/sqlite.28655328.svg";